module.exports = __webpack_public_path__ + "img/icon-speed-7.2bcaff6f.svg";